// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
	text-align: center;
}

.close-button {
	margin-top: -6px;
	padding-right: 13px;
}

.content-title {
	margin-top: 20px;
	margin-bottom: 15px;
	font-family: MuseoSans-500;
	font-size: 24px;
	color: #15325F;
	letter-spacing: 0.01px;
}

.content p {
	margin-bottom: 5px;
	font-family: MuseoSans-300;
	font-size: 12px;
	color:  #3a393a;
	letter-spacing: 0.01px;
	line-height: 1.25;
}

:host >>> .content a {
	color: #00a1e0;
}

.users-list {
	width: 380px;
	border: solid 1px #e6e7e8;
	display: inline-block;
	margin-top: 22px;
	margin-bottom: 21px;
}

.users-list.wide {
	width: 550px;
}

.users-list-head {
	font-family: MuseoSans-500;
	font-size: 13px;
	color: #15325f;
	height: 52px;
	line-height: 52px;
	margin-left: 0px;
	margin-right: 0px;
}

.username, .extension, .email {
	text-align: left;
}

.email {
  word-wrap: break-word;
}

.users-list-head button {
	padding: 0px;
}

.users-list-head button span{
	font-family: MuseoSans-500;
	font-size: 13px;
	color: #15325f;
}

span.arrow {
	margin-left: 9px;
	height: 14px;
}

span.arrow img {
	width: 14px;
	height: 14px;
	vertical-align: -3px;
}

span.arrow-up img {
 transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

ul {
	margin-bottom: 0px;
}

li.ui-state-default {
  background: #fff;
  border: none;
  min-height: 28px;
  vertical-align: middle;
}

li.ui-state-default:first-of-type {
	border-top: solid 1px #e6e7e8;
}

li.ui-state-default:last-child {
  border-bottom: none;
}

li:nth-child(even) {
	background-color: #E7EAEF;  
}

.item {
  padding-top: 5px;
	margin-left: 0px;
	margin-right: 0px;
	font-family: MuseoSans-300;
	font-size: 12px;
	color:  #3a393a;
	letter-spacing: 0px;
	min-height: 28px;
}

.actions {
	position: relative;
	bottom: 20px;
	margin-top: 21px;
}

.btn-primary {
	width: 160px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/users-list-modal/users-list-modal.component.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,eAAe;CACf,eAAe;CACf,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CAIE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;EACE,gBAAgB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,0BAA0B;CAC1B,eAAe;CACf,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb","sourcesContent":[".content {\n\ttext-align: center;\n}\n\n.close-button {\n\tmargin-top: -6px;\n\tpadding-right: 13px;\n}\n\n.content-title {\n\tmargin-top: 20px;\n\tmargin-bottom: 15px;\n\tfont-family: MuseoSans-500;\n\tfont-size: 24px;\n\tcolor: #15325F;\n\tletter-spacing: 0.01px;\n}\n\n.content p {\n\tmargin-bottom: 5px;\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor:  #3a393a;\n\tletter-spacing: 0.01px;\n\tline-height: 1.25;\n}\n\n:host >>> .content a {\n\tcolor: #00a1e0;\n}\n\n.users-list {\n\twidth: 380px;\n\tborder: solid 1px #e6e7e8;\n\tdisplay: inline-block;\n\tmargin-top: 22px;\n\tmargin-bottom: 21px;\n}\n\n.users-list.wide {\n\twidth: 550px;\n}\n\n.users-list-head {\n\tfont-family: MuseoSans-500;\n\tfont-size: 13px;\n\tcolor: #15325f;\n\theight: 52px;\n\tline-height: 52px;\n\tmargin-left: 0px;\n\tmargin-right: 0px;\n}\n\n.username, .extension, .email {\n\ttext-align: left;\n}\n\n.email {\n  word-wrap: break-word;\n}\n\n.users-list-head button {\n\tpadding: 0px;\n}\n\n.users-list-head button span{\n\tfont-family: MuseoSans-500;\n\tfont-size: 13px;\n\tcolor: #15325f;\n}\n\nspan.arrow {\n\tmargin-left: 9px;\n\theight: 14px;\n}\n\nspan.arrow img {\n\twidth: 14px;\n\theight: 14px;\n\tvertical-align: -3px;\n}\n\nspan.arrow-up img {\n\t-moz-transform: scaleY(-1);\n  -o-transform: scaleY(-1);\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\nul {\n\tmargin-bottom: 0px;\n}\n\nli.ui-state-default {\n  background: #fff;\n  border: none;\n  min-height: 28px;\n  vertical-align: middle;\n}\n\nli.ui-state-default:first-of-type {\n\tborder-top: solid 1px #e6e7e8;\n}\n\nli.ui-state-default:last-child {\n  border-bottom: none;\n}\n\nli:nth-child(even) {\n\tbackground-color: #E7EAEF;  \n}\n\n.item {\n  padding-top: 5px;\n\tmargin-left: 0px;\n\tmargin-right: 0px;\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor:  #3a393a;\n\tletter-spacing: 0px;\n\tmin-height: 28px;\n}\n\n.actions {\n\tposition: relative;\n\tbottom: 20px;\n\tmargin-top: 21px;\n}\n\n.btn-primary {\n\twidth: 160px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
